exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-790fe078]:export{menu-bgc-oragne:#F2C46D}.spwwIndexPage[data-v-790fe078]{display:flex;flex-direction:column;height:100%}\n", ""]);

// exports
